<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
    :rules="rules"
  >
    <template slot="form" v-if="model">
      <form-section
        :title="$t('ApplicationForm_NameSectionTitle')"
        :description="$t('ApplicationForm_NameSectionDesc')"
      >
        <el-row>
          <el-col :span="colWidth">
            <rest-form-item
              prop="name"
              :label="$t('ApplicationForm_Field_Name')"
            >
              <el-input v-model="model.name" />
            </rest-form-item>
          </el-col>

          <el-col v-if="$route.query.id" :span="12">
            <rest-form-item
              prop="appkey"
              :label="$t('ApplicationForm_Field_Key')"
            >
              <el-input disabled v-model="model.appkey" />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>

      <application-web-form-page
        v-if="model.type === ApplicationTypes.web"
        :model="model"
        :files="files"
        :readonly="readonly"
      />
      <application-android-form-page
        v-if="model.type === ApplicationTypes.android"
        :model="model"
      />
      <application-ios-form-page
        v-if="model.type === ApplicationTypes.ios"
        :model="model"
        :readonly="readonly"
      />
    </template>
  </rest-form-page>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestFormPage from '@/common/components/rest/RestFormPage'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import ApplicationWebFormPage from '@/modules/account/components/ApplicationWebFormPage'
import ApplicationAndroidFormPage from '@/modules/account/components/ApplicationAndroidFormPage'
import ApplicationIosFormPage from '@/modules/account/components/ApplicationIosFormPage'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'

export default {
  name: 'ApplicationFormPage',

  components: {
    ApplicationIosFormPage,
    ApplicationAndroidFormPage,
    ApplicationWebFormPage,
    RestFormItem,
    FormSection,
    RestFormPage
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      model: this.defaultModel(),
      files: {
        web_icon_small_file: {},
        web_icon_large_file: {},
        ios_production_key_file: {},
        ios_sandbox_key_file: {}
      },
      ApplicationTypes
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `applications/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `applications/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: 'applications'
        })
      }
    },

    rules() {
      return {
        name: {
          required: true
        },
        web_icon_small: {
          required: true
        },
        web_icon_large: [
          {
            required: true
          }
        ]
      }
    },

    colWidth() {
      return this.$route.query.id ? 12 : 24
    },

    optionsEndpoint() {
      return projectEndpoint({ url: 'applications/options' }).url
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {
          type: this.$route.query.type,
          project_id: this.$route.query.project_id
        }
      }
    },

    afterSave(data) {
      this.$store.dispatch('reloadProjectConfig')
      this.$router.push({
        name: 'ApplicationChannels',
        query: {
          id: data.id,
          project_id: this.model.project_id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationFormPage.vue